import gql from 'graphql-tag';

const MaskedPhoneNumber = gql(/* GraphQL */ `
  mutation MaskedPhoneNumber($input: MaskedPhoneNumberInput!) {
    maskedPhoneNumber(input: $input) {
      driverAssignment {
        id
        maskedPhoneNumber
      }
      userErrors {
        ... on UserError {
          message
        }
      }
    }
  }
`);

export default MaskedPhoneNumber;
